<div>
  <div class="bg-white dark:bg-gray-800 m-2 shadow " style="border-radius: 25px;">
    <!--------------------------------------------------- Head ---------------------------------------->
    <div class="flex flex-col justify-center pt-2 px-2">
      <div
        class="flex justify-between item-center gap-2 h-18 px-4 pt-4 mb-2 border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
        <div class="flex items-center mb-4">
          <div class="flex items-center justify-center h-8">
            <img class="w-6 h-6" src="img/stamp-approve-icon.png" alt="Stamp Approve Icon" />
          </div>
          <h1 class="text-2xl font-bold ml-3 my-theme-color-text">
            สร้างคูปอง
          </h1>
        </div>
      </div>
      <div class="p-2 mb-2 flex  items-center relative w-full">
        <div class="relative w-full max-w-md">
          <app-input [placeholder]="'ค้นหารหัสคูปอง'" [type]="'text'" class="dark:text-gray-500"
            [disabledValidate]="true" [valueIn]="searchQuery" (valueOut)="onSearchCoupon($event)"></app-input>
        </div>
        <div class="flex justify-end items-center w-full">
          <button
            class="bg-green-400 hover:bg-green-300 text-white px-5 py-5 rounded-lg  h-9 flex justify-center items-center"
            (click)="openFrom()">
            สร้างคูปอง
          </button>
        </div>
      </div>
    </div>
    <div>
      <!------------------------------------ Table ---------------------------------->
      <div class="overflow-x-auto rounded-t-lg border border-gray-200 dark:border-gray-700" style="height: 600px;">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead class="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 uppercase text-xs">
            <tr>
              <th class="px-4 py-4 text-left">ลำดับ</th>
              <th class="px-4 py-4 text-left">ชื่อ</th>
              <th class="px-4 py-4 text-left">สถานที่ลานจอด</th>
              <th class="px-4 py-4 text-left">ชื่อคูปอง</th>
              <th class="px-4 py-4 text-left">จำนวนคูปอง</th>
              <th class="px-4 py-4 text-left">ราคา</th>
              <th class="px-4 py-4 text-left">เลขที่ใบเสร็จ</th>
              <th class="px-4 py-4 text-left">วันที่สร้าง</th>
              <th class="px-4 py-4 text-center">View</th>
            </tr>
          </thead>

          <tbody
            class="divide-y divide-gray-100 dark:divide-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300">
            <tr *ngFor="let coupon of paginatedData; let i = index"
              class="hover:bg-yellow-50 dark:hover:bg-gray-700 transition cursor-pointer">
              <td class="px-4 py-4">{{ (page - 1) * pageSize + i + 1 }}</td>
              <td class="px-4 py-4">{{ coupon.name }}</td>
              <td class="px-4 py-4">{{ coupon.siteName }}</td>
              <td class="px-4 py-4">{{ coupon.name }}</td>
              <td class="px-4 py-4">{{ coupon.quantity }}</td>
              <td class="px-4 py-4">{{ coupon.fee | number:'1.2-2' }}</td>
              <td class="px-4 py-4">{{ coupon.financeNo }}</td>
              <td class="px-4 py-4">{{ coupon.createDate | date: "dd/MM/yyyy" }}</td>
              <td class="px-4 py-4 text-center">
                <button class="text-white px-3 py-2 rounded-lg text-sm bg-green-400 hover:bg-green-500"
                  (click)="ViewInfo(coupon)">
                  ดูข้อมูล
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ✅ Pagination controls -->
      <div class="flex items-center justify-between rounded-b-3xl"
        style="box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.25);">
        <div>
          <button (click)="page = page - 1" [disabled]="page <= 1"
            class="px-3 py-4 rounded-bl-3xl bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50">
            ก่อนหน้า
          </button>
        </div>

        <span class="text-sm text-gray-700 dark:text-gray-300">
          หน้า {{ page }} จาก {{ totalPages }}
        </span>

        <button (click)="page = page + 1" [disabled]="page >= totalPages"
          class="px-3 py-4 rounded-br-3xl  bg-yellow-400 hover:bg-yellow-300 text-gray-800 disabled:opacity-50">
          ถัดไป
        </button>
      </div>
    </div>
  </div>
</div>


<!------------------------------------------ Modal --------------------------------------->
<!----- Modal Coupon ------>
<div *ngIf="modalCoupon" class="fixed inset-0 z-10 flex items-start justify-center bg-black/50 pt-20 pb-20">
  <!---------------- Modal Box -------------------->
  <div
    class="bg-white dark:bg-gray-800 w-full max-w-screen-sm max-h-screen p-4 sm:p-6 rounded-lg shadow-lg relative overflow-y-auto h-full">
    <div class="mb-6 border-b border-gray-200 dark:border-gray-700 flex items-center">
      <!-- หัวข้อ -->
      <h2 class="text-2xl font-semibold mb-6 text-gray-800 dark:text-gray-200">
        {{
        renew_
        ? "แบบฟอร์มต่ออายุสมาชิกรายเดือน"
        : "แบบฟอร์มทำคูปองส่วนลด"
        }}
      </h2>
      <!-- ปุ่มปิด -->
      <button (click)="modalCoupon = false"
        class="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-red-500 text-5xl">
        &times;
      </button>
    </div>

    <!-- ฟอร์มแบบ 2 คอลัมน์ -->
    <div class="grid grid-cols-1 gap-4 ">
      <!-- ซ้าย -->
      <div>
        <!-- สถานที่ -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            สถานที่ให้บริการลานจอด
          </label>
          <div class="flex gap-2">
            <input type="text" [value]="siteName" readonly
              class="flex-1 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300" />
            <button type="button" (click)="openLocationModal()"
              class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md">
              เลือก
            </button>
          </div>
        </div>

        <div>
          <p class="text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">ชื่อส่วนลด</p>
          <input type="text" max="100" min="0" [(ngModel)]="name" class="  w-full px-4 py-2 border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg text-sm
                          focus:outline-none focus:ring focus:ring-blue-300
                 " />
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทการรับชำระ
          </label>
          <select [(ngModel)]="selectedFeeType" [disabled]="!disabled" (change)="handleFeeType($event)"
            class="w-full px-4 py-2 border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg text-sm">
            <option value="" disabled selected>
              กรุณาเลือกประเภทการรับชำระ
            </option>
            <option *ngFor="let option of FeeTypeOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>


        <div *ngIf="showBank" class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทบัญชีธนาคาร
          </label>
          <select [(ngModel)]="selectedAccountId" (change)="handleAccount($event)"
            class="w-full px-4 py-2 border  border-gray-200 dark:border-gray-600  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg text-sm">
            <option value="" disabled selected>กรุณาเลือกบัญชีธนาคาร</option>
            <option *ngFor="let option of BankOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทรายรับ
          </label>
          <select [(ngModel)]="feeId" (change)="handleFeeId($event)"
            class="w-full px-4 py-2 border  border-gray-200 dark:border-gray-600  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg text-sm">
            <option value="" disabled selected>กรุณาเลือกประเภทรายรับ</option>
            <option *ngFor="let option of FeeIdOptions" [value]="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>

        <div>
          <p class="text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">จำนวนคูปอง</p>
          <input type="number" max="100" min="0" [(ngModel)]="quantity" class="  w-full px-4 py-2 border  border-gray-200 dark:border-gray-600  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg text-sm
                          focus:outline-none focus:ring focus:ring-blue-300
                 " />
        </div>

        <div>
          <p class="text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">เวลาส่วนลด ( นาที )</p>
          <input type="number" max="100" min="0" [(ngModel)]="freeTime" class="  w-full px-4 py-2 border  border-gray-200 dark:border-gray-600  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg text-sm
                          focus:outline-none focus:ring focus:ring-blue-300
                 " />
        </div>

        <div>
          <p class="text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">ราคาคูปอง</p>
          <input type="number" max="100" min="0" [(ngModel)]="fee" class="  w-full px-4 py-2 border  border-gray-200 dark:border-gray-600  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg text-sm
                          focus:outline-none focus:ring focus:ring-blue-300
                 " />
        </div>

        <!-- วันที่ -->
        <div class="my-4 flex gap-4 w-full">
          <div class="w-full">
            <label class="text-sm text-gray-700 dark:text-gray-300 mb-1 block">วันที่เริ่มต้นใช้งาน</label>
            <input type="date" [(ngModel)]="startDate"
              class="border  border-gray-200 dark:border-gray-600  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded px-3 py-2 w-full text-sm" />
          </div>
          <div class="w-full">
            <label class="text-sm text-gray-700 dark:text-gray-300 mb-1 block">วันที่สิ้นสุดการใช้งาน</label>
            <input type="date" [(ngModel)]="endDate"
              class="border  border-gray-200 dark:border-gray-600  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded px-3 py-2 w-full text-sm" />
          </div>
        </div>


        <div class="space-y-4 mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            แนบหลักฐานเพิ่มเติม
          </label>
          <!-- Input เลือกรูป -->
          <label
            class="flex flex-col items-center justify-center w-full h-25 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:bg-gray-800  border-gray-200 dark:border-gray-600  dark:hover:bg-gray-700 transition duration-150 ease-in-out">
            <div class="flex flex-col items-center justify-center py-3">
              <svg class="w-6 h-6 mb-2 text-gray-400 dark:text-gray-300" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18M3 12h18"></path>
              </svg>
              <p class="mb-1 text-sm text-gray-500 dark:text-gray-400 text-center">
                <span class="font-medium">แนบรูป</span>
              </p>
              <p class="text-xs text-gray-400 dark:text-gray-500 text-center">
                รองรับ .JPG, .PNG
              </p>
            </div>

            <input type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)" />
          </label>

          <!-- แสดงรูป preview -->
          <div *ngIf="previewUrl" class="mt-4 items-center justify-center">
            <img [src]="previewUrl" alt="รูปตัวอย่าง" class="max-w-xs h-20 w-50 rounded-lg shadow" />
          </div>
        </div>

        <!-- Tax -->
        <div class="my-4 w-full border-b border-gray-300 dark:border-gray-700 pb-4">
          <div class="flex justify-between items-center gap-2 mt-2 w-full ">
            <label class="text-sm text-gray-700 dark:text-gray-300">ออกใบกำกับภาษี</label>
            <input type="checkbox" [(ngModel)]="isRequestTax"
              class="w-4 h-4 border-gray-300  border-gray-200 dark:border-gray-600  rounded bg-white dark:bg-gray-700 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800" />
          </div>
        </div>

        <div *ngIf="isRequestTax" class="w-full bg-white dark:bg-gray-700 mt-2 rounded-xl shadow-md p-1 space-y-3">
          <div
            class="flex items-center justify-between text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg px-4 py-3 transition duration-200 cursor-pointer"
            (click)="openTaxModal()">
            <div class="flex items-center gap-3">
              <i class="fa-solid fa-receipt text-blue-500 text-sm"></i>
              <span class="text-base">เพิ่มข้อมูลการออกใบกำกับภาษี</span>
            </div>
            <i class="fas fa-chevron-right text-gray-400 dark:text-gray-500"></i>
          </div>
        </div>


        <!-- ปุ่มบันทึก -->
        <div class="md:col-span-2 flex justify-end gap-2 mt-4">
          <button type="button" (click)="modalCoupon = false"
            class="px-4 py-2 dark:text-gray-500 bg-gray-300 rounded hover:bg-gray-400">
            ยกเลิก
          </button>
          <button type="submit" class="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            (click)="submitRequest()">
            {{ renew_ ? "ต่ออายุ" : "สมัคร" }}
          </button>
        </div>
      </div>

    </div>
  </div>

  <!----------- Modal Selected Site ID -------------------->
  <div *ngIf="modalSelectProvider" class="fixed inset-0 z-20 flex items-start top-10 justify-center bg-black/60 pt-10">
    <div
      class="bg-gray-100 w-full max-w-xl p-6 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh] dark:text-gray-700">
      <!-- ปุ่มปิด -->
      <button (click)="modalSelectProvider = false"
        class="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-4xl font-bold">
        &times;
      </button>

      <h2 class="text-xl font-semibold mb-4 ">เลือกผู้ให้บริการลานจอด</h2>

      <!-- ค้นหา -->
      <input type="text" [(ngModel)]="searchProvider" placeholder="ค้นหาชื่อผู้ให้บริการ..."
        class="w-full px-3 py-2 mb-4 border rounded-md focus:outline-none focus:ring focus:ring-blue-300 border-gray-200" />
      <!-- รายการ -->
      <ul class="max-h-64 overflow-y-auto space-y-2">
        <li *ngFor="let provider of filteredProviders()" (click)="selectProvider(provider)"
          class="p-3 bg-gray-100 rounded hover:bg-blue-100 cursor-pointer">
          <div class="font-medium">{{ provider.name }}</div>
          <div class="text-sm text-gray-500">{{ provider.address }}</div>
        </li>
      </ul>
    </div>
  </div>
  <!---------------- Modal Tax -------------------->
  <div *ngIf="showTaxModal" class="fixed inset-0 z-10 flex items-start justify-center bg-black/50 pt-20 px-4">
    <div
      class="bg-white dark:bg-gray-800 rounded-xl p-6 w-full max-w-4xl max-h-[90vh] shadow-lg relative overflow-y-auto max-h-screen">
      <button (click)="closeTaxModal()"
        class="absolute top-4 right-4 text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 text-2xl">
        <i class="fas fa-times"></i>
      </button>

      <h2 class="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6 text-center">
        ขอใบกำกับภาษีแบบเต็มรูป
      </h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm text-gray-700 dark:text-gray-300">
        <!-- ประเภท -->
        <div class="col-span-full">
          <label class="block font-medium text-base">ประเภท</label>
          <select
            class="w-full px-4 py-2 border  border-gray-200 dark:border-gray-600  rounded-lg shadow bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [(ngModel)]="selectedTaxType" (ngModelChange)="filterAddressByTaxType()">
            <option value="1">บุคคลธรรมดา</option>
            <option value="2">นิติบุคคล</option>
          </select>
        </div>

        <!-- เลือกที่อยู่ -->
        <div class="col-span-full" *ngIf="showSelectAddress">
          <div
            class="w-full p-4 border  border-gray-200 dark:border-gray-600  rounded-xl shadow-sm bg-white dark:bg-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 transition flex justify-between items-start"
            (click)="openAddressModal()">
            <div class="flex items-start gap-3">
              <span class="text-orange-500 text-xl mt-1">📍</span>
              <div class="flex flex-col">
                <div class="font-semibold text-base text-gray-800 dark:text-gray-200">
                  {{ selectedAddress?.full_name }}
                  <span class="text-sm text-gray-400 dark:text-gray-500 ml-2">
                    {{ selectedAddress?.phone }}
                  </span>
                </div>
                <div class="text-sm mt-1 leading-snug text-gray-700 dark:text-gray-300">
                  {{ selectedAddress?.company_name }}
                  {{ selectedAddress?.address }}
                  {{ selectedAddress?.sub_district }}
                  {{ selectedAddress?.district }}
                  {{ selectedAddress?.provinces }}
                  {{ selectedAddress?.zip_code }}
                </div>
              </div>
            </div>
            <i class="fas fa-chevron-right text-gray-400 dark:text-gray-500 mt-1"></i>
          </div>
        </div>
        <!-- ภาษี/ที่อยู่ -->
        <div class="sm:col-span-2">
          <label>เลขประจำตัวผู้เสียภาษี</label>
          <div class="flex gap-2">
            <input [(ngModel)]="taxId" type="text"
              class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />
            <button *ngIf="selectedTaxType === '2'" type="button"
              class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-green-600 dark:hover:bg-green-700 whitespace-nowrap"
              (click)="getAddressByTaxId()">
              ค้นหา
            </button>
          </div>
        </div>
        <!-- สำนักงานใหญ่ toggle -->
        <div *ngIf="selectedTaxType === '2'"
          class="flex items-center justify-between col-span-full border-b  border-gray-200 dark:border-gray-600  py-2">
          <span class="text-base text-gray-800 dark:text-gray-200">สำนักงานใหญ่</span>
          <label class="flex items-center gap-2 cursor-pointer text-gray-800 dark:text-gray-200">
            <input type="checkbox" class="w-5 h-5 text-green-600 accent-green-600 focus:ring-green-500 rounded"
              [(ngModel)]="mainOffice" />
            สำนักงานใหญ่
          </label>
        </div>

        <!-- ข้อมูลทั่วไป -->
        <div>
          <label>ชื่อบริษัท / ผู้เสียภาษี</label>
          <input [(ngModel)]="taxName" type="text"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />
        </div>

        <div>
          <label>เบอร์โทรศัพท์</label>
          <input [(ngModel)]="tax_phone" type="text" maxlength="10" pattern="[0-9]*"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />
        </div>

        <div class="sm:col-span-2">
          <label>อีเมล</label>
          <input [(ngModel)]="email" type="text"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />
        </div>

        <!-- ชื่อสาขา -->
        <div *ngIf="!mainOffice && selectedTaxType === '2'">
          <label>ชื่อสาขา</label>
          <input [(ngModel)]="branchName" type="text"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />
        </div>

        <div *ngIf="!mainOffice && selectedTaxType === '2'">
          <label>รหัสประจำสาขา</label>
          <input [(ngModel)]="branchNo" type="text"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />
        </div>

        <div class="sm:col-span-2">
          <label>ที่อยู่</label>
          <input [(ngModel)]="address" type="text"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />
        </div>

        <!-- จังหวัด -->
        <div>
          <label>จังหวัด</label>
          <select [(ngModel)]="selectedProvinceId" (change)="onProvinceChange()"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200">
            <option [value]="null" disabled selected>เลือกจังหวัด</option>
            <option *ngFor="let province of provincess" [value]="province.id">
              {{ province.name_th }}
            </option>
          </select>
        </div>

        <!-- อำเภอ -->
        <div>
          <label>อำเภอ</label>
          <select [(ngModel)]="selectedAmphureId" (change)="onAmphureChange()"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200">
            <option [value]="null" disabled selected>เลือกอำเภอ</option>
            <option *ngFor="let amphure of filteredAmphures" [value]="amphure.id">
              {{ amphure.name_th }}
            </option>
          </select>
        </div>

        <!-- ตำบล -->
        <div>
          <label>ตำบล</label>
          <select [(ngModel)]="selectedTambonId" (change)="onTambonsChange()"
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200">
            <option [value]="null" disabled selected>เลือกตำบล</option>
            <option *ngFor="let tambon of filteredTambons" [value]="tambon.id">
              {{ tambon.name_th }}
            </option>
          </select>
        </div>

        <!-- รหัสไปรษณีย์ -->
        <div>
          <label>เลขไปรษณีย์</label>
          <input type="text" [(ngModel)]="zipcode" readonly
            class="w-full border  border-gray-200 dark:border-gray-600  px-3 py-2 rounded-md bg-gray-100 dark:bg-gray-600 text-gray-800 dark:text-gray-200" />
        </div>
      </div>

      <div class="mt-6 text-center">
        <button class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition" (click)="summit()">
          บันทึก
        </button>
      </div>
    </div>
  </div>

  <!---------------- Modal Vehicle Plate -------------------->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50"
    *ngIf="showModalVehiclePlate">
    <div class="bg-white rounded-lg shadow-lg w-full max-w-md">
      <!---------------- Head  --------------->
      <div class="relative">
        <div class="px-4 py-6">
          <h2 class="text-lg font-bold">กรอกป้ายหมายเลขทะเบียนรถ</h2>
        </div>
        <div class="flex justify-end absolute top-0 right-4">
          <button (click)="toggleModalVehiclePlate()"
            class="text-gray-400 hover:text-gray-600 text-4xl font-bold focus:outline-none">
            &times;
          </button>
        </div>
      </div>

      <div class="border-b border-gray-300 h-[1px] w-full"></div>

      <div class="p-4">
        <!---------- ทะเบียน -------->
        <div>
          <label class="block text-gray-700 text-base mb-2 font-bold">
            <span class="text-red-500">* </span>
            ทะเบียน
          </label>
          <div class="flex gap-2">
            <input [(ngModel)]="licenseTxt" id="codeInvite" type="text" [disabled]="renew_" placeholder="กข1234"
              class="w-full border border-gray-300 rounded-lg px-3 py-2 text-black text-base shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            <!-- [disabled]="!disabled" -->
            <!-- <button
                        type="button"
                        [disabled]="!disabled"
                        class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-green-600 whitespace-nowrap transition-all duration-200 active:scale-95"
                        (click)="toggleOpenSelectVehicleProvince()"
                    >
                        {{ currentLang === "TH" ? "เลือก" : "Select" }}
                    </button> -->
          </div>
        </div>

        <!--------- จังหวัด ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">* </span>จังหวัด
        </label>
        <div class="w-full relative">
          <input
            class="cursor-pointer bg-white dark:bg-gray-700 rounded-lg appearance-none border dark:border-gray-600 w-full py-2 px-3 text-black dark:text-white text-sm leading-tight focus:outline-none focus:shadow-outline"
            id="codeInvite" type="text" [disabled]="!disabled" placeholder="กรุณาเลือกจังหวัด" [(ngModel)]="provinceTxt"
            readonly [disabled]="renew_" (click)="isOpen = !isOpen" />
          <div class="relative items-center w-full">
            <div *ngIf="isOpen"
              class="absolute w-full mt-2 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 p-1 space-y-1 max-h-60 overflow-y-auto">
              <input [(ngModel)]="searchTerm" [disabled]="!disabled"
                class="bg-white dark:bg-gray-700 border dark:border-gray-600 rounded-lg w-full py-2 px-3 text-sm text-gray-800 dark:text-gray-200 focus:outline-none focus:shadow-outline"
                type="text" placeholder="ค้นหาจังหวัด" autocomplete="off" />

              <div *ngFor="let province of filterProvinces()">
                <a (click)="selectProvince(province)"
                  class="block px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 active:bg-blue-100 dark:active:bg-gray-600 cursor-pointer rounded-md">
                  {{ province.value }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!--------- ยี่ห้อ ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">*</span>
          ยี่ห้อ
        </label>
        <select [(ngModel)]="brandTxt" [disabled]="!disabled" [disabled]="renew_" (change)="handleBrandChange($event)"
          class="w-full px-4 py-2 border dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-base shadow"
          [ngClass]="{
            'text-gray-400 dark:text-gray-500': selectedBrand === '',
            'text-gray-700 dark:text-gray-200': selectedBrand !== ''
          }">
          <option value="" disabled selected>กรุณาเลือกยี่ห้อ</option>
          <option *ngFor="let option of BrandOptions" [value]="option.value" [disabled]="option.value === ''">
            {{ option.label }}
          </option>
        </select>

        <!--------- รุ่น ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">*</span>
          รุ่น
        </label>

        <select [(ngModel)]="modelTxt" [disabled]="!disabled" [disabled]="renew_" (change)="handleModelChange($event)"
          class="w-full px-4 py-2 border dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-sm" [ngClass]="{
            'text-gray-400 dark:text-gray-500': insertLicensePlate.model === '',
            'text-gray-700 dark:text-gray-200': insertLicensePlate.model !== ''
          }">
          <option value="" disabled selected>กรุณาเลือกรุ่น</option>
          <option *ngFor="let option of ModelOptions" [value]="option.value" [disabled]="option.value === ''">
            {{ option.label }}
          </option>
        </select>

        <!--------- สี ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">*</span>
          สี
        </label>
        <select [(ngModel)]="colorTxt" (change)="handleColorChange($event)"
          class="w-full px-4 py-2 border dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-base shadow"
          [ngClass]="{
            'text-gray-400 dark:text-gray-500': colorTxt === '',
            'text-gray-700 dark:text-gray-200': colorTxt !== ''
          }">
          <option value="" disabled selected>กรุณาเลือกสี</option>
          <option *ngFor="let option of ColorOptions" [value]="option.value" [disabled]="option.value === ''">
            {{ option.label }}
          </option>
        </select>

        <!--------- ปุ่ม ---------->
        <button class="w-full bg-green-500 text-white rounded-md p-2 mt-4 transition-colors"
          (click)="submitModalVehiclePlate()" type="submit">
          ยืนยัน
        </button>
      </div>
    </div>
  </div>
</div>

<!----- Modal Coupon View ------>
<div *ngIf="modalViewCouponInfo" class="fixed inset-0 z-10 flex items-start justify-center bg-black/50 pt-20 pb-20">
  <!---------------- Modal Box -------------------->
  <div
    class="bg-white dark:bg-gray-800 w-full max-w-screen-sm max-h-screen p-4 sm:p-6 rounded-lg shadow-lg relative overflow-y-auto h-full">
    <div class="mb-6 border-b border-gray-200 dark:border-gray-700 flex items-center">
      <!-- หัวข้อ -->
      <h2 class="text-2xl font-semibold mb-6 text-gray-800 dark:text-gray-200">
        {{
        "แบบฟอร์มทำคูปองส่วนลด"
        }}
      </h2>
      <!-- ปุ่มปิด -->
      <button (click)="modalViewCouponInfo = false"
        class="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-red-500 text-5xl">
        &times;
      </button>
    </div>

    <!-- ฟอร์มแบบ 2 คอลัมน์ -->
    <div class="grid grid-cols-1 gap-4 ">
      <!-- ซ้าย -->
      <div>
        <!-- สถานที่ -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            สถานที่ให้บริการลานจอด
          </label>
          <div class="flex gap-2">
            <input type="text" [value]="siteName" readonly
              class="flex-1 px-3 py-2 text-sm border dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600" />
            <!-- <button
              type="button"
              (click)="openLocationModal()"
              class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md"
            >
              เลือก
            </button> -->
          </div>
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทการรับชำระ
          </label>
          <div class="flex gap-2 border dark:border-gray-600 border-gray-300 rounded-lg">
            <input type="text" [value]="financeDetailsData.feeTypeId" readonly
              class="flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          </div>
        </div>


        <div *ngIf="showBank" class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทบัญชีธนาคาร
          </label>
          <div class="flex gap-2 border border-gray-300 dark:border-gray-600 rounded-lg">
            <input type="text" [value]="selectedAccountId" readonly
              class="flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          </div>
          <!-- <select
            [(ngModel)]="selectedAccountId"
            (change)="handleAccount($event)"
            class="w-full px-4 py-2 border rounded-lg text-sm"
          >
            <option value="" disabled selected>กรุณาเลือกบัญชีธนาคาร</option>
            <option *ngFor="let option of BankOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select> -->
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทรายรับ
          </label>
          <div class="flex gap-2 border border-gray-300 dark:border-gray-600 rounded-lg">
            <input type="text" [value]="financeDetailsData.feeId" readonly
              class="flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          </div>
          <!-- <select
            [(ngModel)]="feeId"
            (change)="handleFeeId($event)"
            class="w-full px-4 py-2 border rounded-lg text-sm"
          >
            <option value="" disabled selected>กรุณาเลือกประเภทรายรับ</option>
            <option *ngFor="let option of FeeIdOptions" [value]="option.id">
              {{ option.name }}
            </option>
          </select> -->
        </div>

        <div class="mb-4 w-full">
          <p class="text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">จำนวนคูปองที่ทำส่วนลดได้</p>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.quantity" readonly readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <div>
          <p class="text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">เวลาส่วนลด ( นาที )</p>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.freeTime" readonly
            class="  w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <div>
          <p class="text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">ราคาคูปอง</p>
          <input type="number" max="100" min="0" readonly [(ngModel)]="financeDetailsData.fee"
            class="  w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg " />
        </div>

        <!-- วันที่ -->
        <div class="my-4 flex gap-4 w-full">
          <div class="w-full">
            <label class="text-sm text-gray-700 dark:text-gray-300 mb-1 block">วันที่เริ่มต้นใช้งาน</label>
            <input type="date" [(ngModel)]="financeDetailsData.startDate" readonly
              class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          </div>
          <div class="w-full">
            <label class="text-sm text-gray-700 dark:text-gray-300 mb-1 block">วันที่สิ้นสุดการใช้งาน</label>
            <input type="date" [(ngModel)]="financeDetailsData.endDate" readonly
              class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          </div>
        </div>


        <div class="space-y-4 mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            แนบหลักฐานเพิ่มเติม
          </label>
          <!-- Input เลือกรูป -->
          <!-- <label
            class="flex flex-col items-center justify-center w-full h-25 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-600 dark:hover:bg-gray-700 transition duration-150 ease-in-out"
          >
            <div class="flex flex-col items-center justify-center py-3">
              <svg
                class="w-6 h-6 mb-2 text-gray-400 dark:text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18M3 12h18"
                ></path>
              </svg>
              <p
                class="mb-1 text-sm text-gray-500 dark:text-gray-400 text-center"
              >
                <span class="font-medium">แนบรูป</span>
              </p>
              <p class="text-xs text-gray-400 dark:text-gray-500 text-center">
                รองรับ .JPG, .PNG
              </p>
            </div>

            <input
              type="file"
              accept="image/*"
              class="hidden"
              (change)="onFileSelected($event)"
            />
          </label> -->

          <!-- แสดงรูป preview -->
          <div *ngIf="previewUrl" class="mt-4 items-center justify-center">
            <img [src]="previewUrl" alt="รูปตัวอย่าง" class="max-w-xs h-20 w-50 rounded-lg shadow" />
          </div>
        </div>

        <!-- Tax -->
        <!-- <div class="my-4 w-full border-b border-gray-300 pb-4">
          <div class="flex justify-between items-center gap-2 mt-2 w-full ">
            <label class="text-sm text-gray-700">ออกใบกำกับภาษี</label>
            <input
              type="checkbox"
              [(ngModel)]="isRequestTax"
              class="w-4 h-4 border-gray-300 rounded"
            />
          </div>
        </div> -->

        <div *ngIf="isRequestTax" class="w-full bg-white dark:bg-gray-700 mt-2 rounded-xl shadow-md p-1 space-y-3">
          <div
            class="flex items-center justify-between text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg px-4 py-3 transition duration-200 cursor-pointer"
            (click)="openTaxModal()">
            <div class="flex items-center gap-3">
              <i class="fa-solid fa-receipt text-blue-500 text-sm"></i>
              <span class="text-base">ดูข้อมูลการออกใบกำกับภาษี</span>
            </div>
            <i class="fas fa-chevron-right text-gray-400 dark:text-gray-500"></i>
          </div>
        </div>


        <!-- ปุ่มบันทึก -->
        <div class="md:col-span-2 flex justify-end gap-2 mt-4">
          <button type="button" (click)="modalViewCouponInfo = false"
            class="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded hover:bg-gray-400 dark:hover:bg-gray-500">
            ยกเลิก
          </button>
        </div>
      </div>

    </div>
  </div>

  <!----------- Modal Selected Site ID -------------------->
  <div *ngIf="modalSelectProvider"
    class="fixed inset-0 z-20 flex items-start top-0 justify-center bg-black bg-opacity-60 pt-10">
    <div
      class="bg-white dark:bg-gray-800 w-full max-w-xl p-6 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh]">
      <!-- ปุ่มปิด -->
      <button (click)="modalSelectProvider = false"
        class="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-red-500 text-4xl font-bold">
        &times;
      </button>

      <h2 class="text-xl font-semibold mb-4 text-gray-800 dark:text-gray-200">เลือกผู้ให้บริการลานจอด</h2>

      <!-- ค้นหา -->
      <input type="text" [(ngModel)]="searchProvider" placeholder="ค้นหาชื่อผู้ให้บริการ..."
        class="w-full px-3 py-2 mb-4 border dark:border-gray-600 rounded-md focus:outline-none focus:ring focus:ring-blue-300 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200" />

      <!-- รายการ -->
      <ul class="max-h-64 overflow-y-auto space-y-2">
        <li *ngFor="let provider of filteredProviders()" (click)="selectProvider(provider)"
          class="p-3 bg-gray-100 dark:bg-gray-700 rounded hover:bg-blue-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200">
          <div class="font-medium">{{ provider.name }}</div>
          <div class="text-sm text-gray-500 dark:text-gray-400">{{ provider.address }}</div>
        </li>
      </ul>
    </div>
  </div>
  <!---------------- Modal Tax -------------------->
  <div *ngIf="showTaxModal" class="fixed inset-0 z-10 flex items-start justify-center bg-black/50 pt-3 px-4">
    <div
      class="bg-white dark:bg-gray-800 rounded-xl p-6 w-full max-w-4xl max-h-[90vh] shadow-lg relative overflow-y-auto max-h-screen">
      <button (click)="closeTaxModal()"
        class="absolute top-4 right-4 text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 text-2xl">
        <i class="fas fa-times"></i>
      </button>

      <h2 class="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6 text-center">
        ขอใบกำกับภาษีแบบเต็มรูป
      </h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm text-gray-700 dark:text-gray-300">
        <!-- ประเภท -->
        <div class="col-span-full">
          <label class="block font-medium text-base">ประเภท</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.addressType" readonly readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          <!-- <select
            class="w-full px-4 py-2 border rounded-lg shadow"
            [(ngModel)]="selectedTaxType"
            (ngModelChange)="filterAddressByTaxType()"
          >
            <option value="1">บุคคลธรรมดา</option>
            <option value="2">นิติบุคคล</option>
          </select> -->
        </div>

        <!-- เลือกที่อยู่ -->
        <!-- <div class="col-span-full" *ngIf="showSelectAddress">
          <div
            class="w-full p-4 border rounded-xl shadow-sm bg-white cursor-pointer hover:bg-gray-50 transition flex justify-between items-start"
            (click)="openAddressModal()"
          >
            <div class="flex items-start gap-3">
              <span class="text-orange-500 text-xl mt-1">📍</span>
              <div class="flex flex-col">
                <div class="font-semibold text-base">
                  {{ selectedAddress?.full_name }}
                  <span class="text-sm text-gray-400 ml-2">
                    {{ selectedAddress?.phone }}
                  </span>
                </div>
                <div class="text-sm mt-1 leading-snug text-gray-700">
                  {{ selectedAddress?.company_name }}
                  {{ selectedAddress?.address }}
                  {{ selectedAddress?.sub_district }}
                  {{ selectedAddress?.district }}
                  {{ selectedAddress?.provinces }}
                  {{ selectedAddress?.zip_code }}
                </div>
              </div>
            </div>
            <i class="fas fa-chevron-right text-gray-400 mt-1"></i>
          </div>
        </div> -->
        <!-- ภาษี/ที่อยู่ -->
        <div class="sm:col-span-2">
          <label>เลขประจำตัวผู้เสียภาษี</label>
          <div class="flex gap-2">
            <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.taxId" readonly
              class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
            <!-- <input
              [(ngModel)]="taxId"
              type="text"
              class="w-full border px-3 py-2 rounded-md"
            />
            <button
              *ngIf="selectedTaxType === '2'"
              type="button"
              class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-green-600 whitespace-nowrap"
              (click)="getAddressByTaxId()"
            >
              ค้นหา
            </button> -->
          </div>
        </div>
        <!-- สำนักงานใหญ่ toggle -->
        <div *ngIf="financeDetailsData.addressType === 2"
          class="flex items-center justify-between col-span-full border-b dark:border-gray-600 py-2">
          <span class="text-base text-gray-800 dark:text-gray-200">สำนักงานใหญ่</span>
          <label class="flex items-center gap-2 cursor-pointer text-gray-800 dark:text-gray-200">
            <input type="checkbox" value="true" readonly
              class="w-5 h-5 text-green-600 accent-green-600 focus:ring-green-500 rounded" />
            สำนักงานใหญ่
          </label>
        </div>

        <!-- ข้อมูลทั่วไป -->
        <div>
          <label>ชื่อบริษัท / ผู้เสียภาษี</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.fullName" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <div>
          <label>เบอร์โทรศัพท์</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.phone" maxlength="10" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <div class="sm:col-span-2">
          <label>อีเมล</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.email" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <!-- ชื่อสาขา -->
        <div *ngIf="financeDetailsData.addressType === 2">
          <label>ชื่อสาขา</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.branch" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <div *ngIf="financeDetailsData.addressType === 2">
          <label>รหัสประจำสาขา</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.branchNo" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <div class="sm:col-span-2">
          <label>ที่อยู่</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.address" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>

        <!-- จังหวัด -->
        <div>
          <label>จังหวัด</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.provinces" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          <!-- <select
            [(ngModel)]="selectedProvinceId"
            (change)="onProvinceChange()"
            class="w-full border px-3 py-2 rounded-md"
          >
            <option [value]="null" disabled selected>เลือกจังหวัด</option>
            <option *ngFor="let province of provincess" [value]="province.id">
              {{ province.name_th }}
            </option>
          </select> -->
        </div>

        <!-- อำเภอ -->
        <div>
          <label>อำเภอ</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.subDistrict" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          <!-- <select
            [(ngModel)]="selectedAmphureId"
            (change)="onAmphureChange()"
            class="w-full border px-3 py-2 rounded-md"
          >
            <option [value]="null" disabled selected>เลือกอำเภอ</option>
            <option
              *ngFor="let amphure of filteredAmphures"
              [value]="amphure.id"
            >
              {{ amphure.name_th }}
            </option>
          </select> -->
        </div>

        <!-- ตำบล -->
        <div>
          <label>ตำบล</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.district" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
          <!-- <select
            [(ngModel)]="selectedTambonId"
            (change)="onTambonsChange()"
            class="w-full border px-3 py-2 rounded-md"
          >
            <option [value]="null" disabled selected>เลือกตำบล</option>
            <option *ngFor="let tambon of filteredTambons" [value]="tambon.id">
              {{ tambon.name_th }}
            </option>
          </select> -->
        </div>

        <!-- รหัสไปรษณีย์ -->
        <div>
          <label>เลขไปรษณีย์</label>
          <input type="number" max="100" min="0" [(ngModel)]="financeDetailsData.zipCode" readonly
            class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 rounded-lg" />
        </div>
      </div>

      <div class="mt-6 text-center">
        <button class="px-6 py-2 bg-gray-400 text-white rounded-lg transition" (click)="summit()">
          ยกเลิก
        </button>
      </div>
    </div>
  </div>

  <!---------------- Modal Vehicle Plate -------------------->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50"
    *ngIf="showModalVehiclePlate">
    <div class="bg-white rounded-lg shadow-lg w-full max-w-md">
      <!---------------- Head  --------------->
      <div class="relative">
        <div class="px-4 py-6">
          <h2 class="text-lg font-bold">กรอกป้ายหมายเลขทะเบียนรถ</h2>
        </div>
        <div class="flex justify-end absolute top-0 right-4">
          <button (click)="toggleModalVehiclePlate()"
            class="text-gray-400 hover:text-gray-600 text-4xl font-bold focus:outline-none">
            &times;
          </button>
        </div>
      </div>

      <div class="border-b border-gray-300 h-[1px] w-full"></div>

      <div class="p-4">
        <!---------- ทะเบียน -------->
        <div>
          <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 font-bold">
            <span class="text-red-500">* </span>
            ทะเบียน
          </label>
          <div class="flex gap-2">
            <input [(ngModel)]="licenseTxt" id="codeInvite" type="text" [disabled]="renew_" placeholder="กข1234"
              class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-black dark:text-white bg-white dark:bg-gray-700 text-base shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            <!-- [disabled]="!disabled" -->
            <!-- <button
                        type="button"
                        [disabled]="!disabled"
                        class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-green-600 whitespace-nowrap transition-all duration-200 active:scale-95"
                        (click)="toggleOpenSelectVehicleProvince()"
                    >
                        {{ currentLang === "TH" ? "เลือก" : "Select" }}
                    </button> -->
          </div>
        </div>

        <!--------- จังหวัด ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">* </span>จังหวัด
        </label>
        <div class="w-full relative">
          <input
            class="cursor-pointer bg-white dark:bg-gray-700 rounded-lg appearance-none border dark:border-gray-600 w-full py-2 px-3 text-black dark:text-white text-sm leading-tight focus:outline-none focus:shadow-outline"
            id="codeInvite" type="text" [disabled]="!disabled" placeholder="กรุณาเลือกจังหวัด" [(ngModel)]="provinceTxt"
            readonly [disabled]="renew_" (click)="isOpen = !isOpen" />
          <div class="relative items-center w-full">
            <div *ngIf="isOpen"
              class="absolute w-full mt-2 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 p-1 space-y-1 max-h-60 overflow-y-auto">
              <input [(ngModel)]="searchTerm" [disabled]="!disabled"
                class="bg-white dark:bg-gray-700 border dark:border-gray-600 rounded-lg w-full py-2 px-3 text-sm text-gray-800 dark:text-gray-200 focus:outline-none focus:shadow-outline"
                type="text" placeholder="ค้นหาจังหวัด" autocomplete="off" />

              <div *ngFor="let province of filterProvinces()">
                <a (click)="selectProvince(province)"
                  class="block px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 active:bg-blue-100 dark:active:bg-gray-600 cursor-pointer rounded-md">
                  {{ province.value }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!--------- ยี่ห้อ ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">*</span>
          ยี่ห้อ
        </label>
        <select [(ngModel)]="brandTxt" [disabled]="!disabled" [disabled]="renew_" (change)="handleBrandChange($event)"
          class="w-full px-4 py-2 border dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-base shadow"
          [ngClass]="{
            'text-gray-400 dark:text-gray-500': selectedBrand === '',
            'text-gray-700 dark:text-gray-200': selectedBrand !== ''
          }">
          <option value="" disabled selected>กรุณาเลือกยี่ห้อ</option>
          <option *ngFor="let option of BrandOptions" [value]="option.value" [disabled]="option.value === ''">
            {{ option.label }}
          </option>
        </select>

        <!--------- รุ่น ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">*</span>
          รุ่น
        </label>

        <select [(ngModel)]="modelTxt" [disabled]="!disabled" [disabled]="renew_" (change)="handleModelChange($event)"
          class="w-full px-4 py-2 border dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-sm" [ngClass]="{
            'text-gray-400 dark:text-gray-500': insertLicensePlate.model === '',
            'text-gray-700 dark:text-gray-200': insertLicensePlate.model !== ''
          }">
          <option value="" disabled selected>กรุณาเลือกรุ่น</option>
          <option *ngFor="let option of ModelOptions" [value]="option.value" [disabled]="option.value === ''">
            {{ option.label }}
          </option>
        </select>

        <!--------- สี ---------->
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
          <span class="text-red-500">*</span>
          สี
        </label>
        <select [(ngModel)]="colorTxt" (change)="handleColorChange($event)"
          class="w-full px-4 py-2 border dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-base shadow"
          [ngClass]="{
            'text-gray-400 dark:text-gray-500': colorTxt === '',
            'text-gray-700 dark:text-gray-200': colorTxt !== ''
          }">
          <option value="" disabled selected>กรุณาเลือกสี</option>
          <option *ngFor="let option of ColorOptions" [value]="option.value" [disabled]="option.value === ''">
            {{ option.label }}
          </option>
        </select>

        <!--------- ปุ่ม ---------->
        <button class="w-full bg-green-500 text-white rounded-md p-2 mt-4 transition-colors"
          (click)="submitModalVehiclePlate()" type="submit">
          ยืนยัน
        </button>
      </div>
    </div>
  </div>
</div>